import React, { Component } from 'react'

import { Grid } from '@mui/material'
import debounce from 'lodash/debounce'
import isEqual from 'lodash/isEqual'

import { campaignStatusesMap } from '@albacross/frontend-utils'

import {
  type DateRange,
  FormAutoComplete,
  FormCustomerMultiSelect,
  FormDateRangePicker,
  FormMultiSelect,
  FormSelect,
  FormTextField,
} from 'components/input'
import { INITIAL_CAMPAIGNS_FILTERS } from 'constants/campaigns-filters'
import { withForm } from 'decorators/withForm'
import { assignableUsersOptions } from 'models/campaign-model'
import { getCountryMap } from 'utils/countries'

const paidStatusOptions = [
  { value: 'true', label: 'Paid' },
  { value: 'false', label: 'Unpaid' },
]

const statusOptions = [...campaignStatusesMap].map(([value, label]) => ({ value, label }))

const countries = [...getCountryMap()].map(([iso, country]: any) => ({ value: iso, label: country.printableName }))

type CampaignsFiltersProps = {
  setFilters?: (...args: any[]) => any
  change?: (field: string, value: unknown) => void
  initialValues?: Record<string, any>
}

class CampaignsFilters extends Component<CampaignsFiltersProps> {
  // The default Review + Running hides everything that has since finished, i.e. most of a past month.
  // Only the untouched default is cleared, so a status the user picked on purpose survives.
  handlePeriodChange = (period: DateRange | null) => {
    const status = this.props.initialValues?.status
    if (period && isEqual(status, INITIAL_CAMPAIGNS_FILTERS.status)) this.props.change?.('status', [])
  }

  render() {
    return (
      <Grid container spacing={2} style={{ width: 1000 }} sx={{ justifyContent: 'flex-end', pt: 2 }}>
        <Grid
          size={{
            sm: 8,
          }}>
          <FormCustomerMultiSelect label="Customers" name="customers" />
        </Grid>
        <Grid
          size={{
            sm: 4,
          }}>
          <FormDateRangePicker label="Time frame" name="period" onChange={this.handlePeriodChange} />
        </Grid>
        <Grid
          size={{
            sm: 3,
          }}>
          <FormTextField label="Search..." name="query" />
        </Grid>
        <Grid
          size={{
            sm: 2,
          }}>
          <FormSelect label="Paid Status" name="paidStatus" options={paidStatusOptions} />
        </Grid>
        <Grid
          size={{
            sm: 2,
          }}>
          <FormMultiSelect label="Status" name="status" options={statusOptions} />
        </Grid>
        <Grid
          size={{
            sm: 3,
          }}>
          <FormAutoComplete label="Countries" name="countries" options={countries} />
        </Grid>
        <Grid
          size={{
            sm: 2,
          }}>
          <FormMultiSelect label="Assignee" name="adops" options={assignableUsersOptions} />
        </Grid>
      </Grid>
    )
  }
}

export default withForm({
  form: 'campaignsFilters',
  onChange: debounce((values: any, _dispatch: any, props: any) => props.setFilters(values), 500),
})(CampaignsFilters)
